module.exports = __webpack_public_path__ + "static/media/place-of-worship.0fec28f0.svg";